import React from "react";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Industries } from "./components/Industries";
import { Work } from "./components/Work";
import { Process } from "./components/Process";
import { Engagement } from "./components/Engagement";
import { Stack } from "./components/Stack";
import { Testimonials } from "./components/Testimonials";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

export const App = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <Nav />
      <Hero />
      <Services />
      <Industries />
      <Work />
      <Process />
      <Engagement />
      <Stack />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};
